import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionD');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                pc="https://websiteoss.ecoflow.com/upload/image/1724570980040/sectionD.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724571512423/sectionD_h5.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                hasAnimation={false}
            />
            <EfSpec />
        </div>
    );
}
